export enum TooltipPosition {
  Auto = 'auto',
  Top = 'top',
  Bottom = 'bottom',
  Left = 'left',
  Right = 'right',
}

export enum BeaconPosition {
  Left = 'left',
  Right = 'right',
}
